import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AlertifyService } from '../common/services/alertify.service';
import { ReportRequestVM, DateRangeReportVM, OperationResult, CARDEXReport } from '../models/view-models';
import { map } from 'rxjs/operators';
import { ErrorService } from '../interceptors/error.service';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  apiUrl: string = `${environment.apiUrl}/Reports`;

  constructor(private http: HttpClient,
    private error: ErrorService,
    private alertify: AlertifyService) { }

  createDateRangeReport(reportRequest: ReportRequestVM) {
    const uri = `${this.apiUrl}/CreateDateRangeReport`;
    return this.http.post(uri, reportRequest)
      .pipe(map((response: OperationResult<DateRangeReportVM>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.error.logError(response);
          return null;
        }
      }));
  }
  
  createCARDEXReport(reportRequest: ReportRequestVM) {
    const uri = `${this.apiUrl}/CreateCARDEXReport`;
    return this.http.post(uri, reportRequest)
      .pipe(map((response: OperationResult<CARDEXReport[]>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.error.logError(response);
          return null;
        }
      }));
  }

}
